export default "__VITE_ASSET__DEDjBbQJ__"